import { createFetchReducer } from '@copilot/common/store/reducers/fetch';
import { ORGANIZATION_MEMBERS } from './constant';

export default createFetchReducer(ORGANIZATION_MEMBERS);
